import klDivergence from "./NotesContent/Probability/kl-divergence";
import cmputVision from "./NotesContent/CmputVision/cmput_vision";
import timeSeries from "./NotesContent/TimeSeries/time_series";

export const notes = [
  {
    id: "kl-divergence",
    title: "MLE amoounts to minimizing KL Divergence",
    category: "Probability",
    tags: ["probability", "information-theory"],
    content: klDivergence,
  },
  {
    id: "Cmput Vision",
    title : "Computer Vision Notes",
    category: "Numeric Methods, Linear Algebra, ML",
    tags: ["computer-vision", "ml", "linear-algebra"],
    content: cmputVision,
  },
  {
    id: "Time Series Analysis",
    title: "Time Series Analysis Notes",
    category: "Statistics",
    tags: ["time-series", "statistics"],
    content: timeSeries,
  }
];
